import React, { useState } from 'react';
import productsList from '../Assets/Products';

export default function ProductsPage() {
  const [sortOption, setSortOption] = useState('');

  const extractStorage = (storage) => {
    const match = storage?.match(/(\d+)\s*GB\s*RAM\s*\/\s*(\d+)\s*GB\s*ROM/i);
    return match ? parseInt(match[2], 10) : 0; // Only ROM
  };
  const parsePrice = (price) => {
  if (typeof price === 'number') return price;
  return parseInt(String(price).replace(/[^\d]/g, ''), 10); // removes ₹ and commas
};

const getSortedProducts = () => {
  const sorted = [...productsList];

  switch (sortOption) {
    case 'price-asc':
      return sorted.sort((a, b) => parsePrice(a.price) - parsePrice(b.price));
    case 'price-desc':
      return sorted.sort((a, b) => parsePrice(b.price) - parsePrice(a.price));
    case 'storage-asc':
      return sorted.sort((a, b) => extractStorage(a.storage) - extractStorage(b.storage));
    case 'storage-desc':
      return sorted.sort((a, b) => extractStorage(b.storage) - extractStorage(a.storage));
    default:
      return sorted;
  }
};

  const sortedProducts = getSortedProducts();

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-200 py-12 px-4 font-poppins">
      <div className="max-w-7xl mx-auto">
        {/* Heading */}
        <h2 className="text-4xl font-extrabold text-center mb-10 text-gray-800 tracking-tight">
          📱 Available Mobile Phones
        </h2>

        {/* Sort Options */}
        <div className="flex justify-end mb-8">
          <label htmlFor="sort" className="mr-3 text-gray-700 font-medium">
            Sort by:
          </label>
          <select
            id="sort"
            value={sortOption}
            onChange={(e) => setSortOption(e.target.value)}
            className="bg-white border border-gray-300 rounded-lg shadow-sm px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="">Default</option>
            <option value="price-asc">Price: Low to High</option>
            <option value="price-desc">Price: High to Low</option>
            <option value="storage-asc">Storage: Low to High</option>
            <option value="storage-desc">Storage: High to Low</option>
          </select>
        </div>

        {/* Product Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
          {sortedProducts.map((product) => (
            <div
              key={product.id}
              className="bg-white rounded-2xl shadow-md hover:shadow-xl transition duration-300 p-5 flex flex-col"
            >
              <img
                src={product.image}
                alt={product.name}
                className="h-48 w-full object-contain mb-4 rounded-md"
              />
              <h3 className="text-lg font-semibold text-gray-800 mb-1 line-clamp-2">
                {product.name}
              </h3>
              <p className="text-sm text-gray-600 mb-1">{product.storage}</p>
              <p className="text-black-600 font-bold text-lg mb-4">
                Rs. {product.price}
              </p>
              <a
                href={product.buyLink}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-auto bg-[#00AEEA] hover:bg-blue-700 text-white text-center py-2 px-4 rounded-lg font-medium transition duration-300"
              >
                Buy Now
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
